import React from 'react';
import { translate } from '../Services/translation';

export default ({ optionData }) => (
  <>
    {optionData.configurationData && (
      <>
        {optionData.configurationData.width && (
          <div className="[ text-small lh-1 color-grey-500 ] [ cart-container__option ]">
            {translate('cart.options.width')}:{' '}
            {optionData.configurationData.width}
          </div>
        )}
        {optionData.configurationData.length && (
          <div className="[ text-small lh-1 color-grey-500 ] [ cart-container__option ]">
            {translate('cart.options.length')}:{' '}
            {optionData.configurationData.length}
          </div>
        )}
        {optionData.configurationData.additionalOptions &&
          optionData.configurationData.additionalOptions?.map(
            (additionalInfo, index) => (
              <div
                className="[ text-small lh-1 color-grey-500 ] [ cart-container__additionalInfo ]"
                key={`${additionalInfo}_${index}`}
              >{`${additionalInfo}: ${translate('cart.options.yes')}`}</div>
            )
          )}
      </>
    )}
    {optionData.note && (
      <div className="[ text-small lh-1 color-grey-500 ] [ cart-container__option ]">
        {`${translate('cart.options.note')}: ${optionData.note}`}
      </div>
    )}
  </>
);
